import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { TokenService } from './services/token.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../environments/environment.prod';

@Injectable()
export class Httprequestintercept implements HttpInterceptor {
  constructor(private tokenService: TokenService) { }
  baseUrl: string = environment.baseUrl;
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let authReq = req;
    let authToken = this.tokenService.getToken();
    if (req.url.includes('login.php') || req.url.includes('get_otp.php')) {
      authToken = null;
    }
    if (!authToken) {
      const authCode = 12345;
      authReq = req.clone({
        headers: req.headers
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('auth-code', authCode.toString()),
      });
    } else {
      const authCode2 = authToken;
      if (req.url.includes('insert_pic.php') || req.url.includes('editintel.php') || req.url.includes('capture_edit.php') || req.url.includes('add_pic.php') || req.url.includes('capture.php') || req.url.includes('upload_thumbs.php') || req.url.includes('insert_doc_comments.php') || req.url.includes('d_Message.php') || req.url.includes('export.php') || req.url.includes('intel.php') || req.url.includes('get_user_otp.php') || req.url.includes('update_mobile.php') || req.url.includes('upload_company_logo.php') || req.url.includes('upload_brand_logo.php')) {
        authReq = req.clone({
          headers: req.headers
            .set('auth-code', authCode2.toString()),
        });
      }
      else {
        authReq = req.clone({
          headers: req.headers
            .set('auth-code', authCode2.toString())
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
        });
      }

    }
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );

  }
}
